Revolution.Module.extend({
    NAME: "mde.forms", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        //events
        this.initInputFile();

        $('.label-number').closest('label').prev().on('change', this.checkboxesCounter);
        $('.js-uncheck-options').on('click', this.uncheckOptions);

        $('body').on('change', '.js-conditional-radio', this.conditionnalRadio);

        $('body').on('click', '.js-add-form-line', this.addFormLine);
        $('body').on('click', '.js-remove-line', this.removeFormLine);
        $('body').on('click', '.js-toggle-password', this.toggleInputPassword);
        $('body').on('click', '.js-btn-modify', this.modifyAccount);


        $('.js-only-numbers').mask('0#');

        this.initFormWithParsley();
        this.initSelect();

        $('body').on('click', '.js-btn-favorite', this.clickFavorite);
        $('body').on('click', '.js-btn-delete-all-favorite', this.deleteAllFavorite);
        this.getFavorite();

        this.tagFormWithoutLegend();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },

    removeFormLine: function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('.js-added-line').remove();
    },

    addFormLine: function (e) {
        var $obj = $(e.currentTarget);
        var $parent = $obj.closest('.js-add-form-line-wrapper');
        var templating = $parent.find('[type="text/template"]').html();
        var $wrapper = $parent.find('.js-insert-wrapper');
        var nblines = $wrapper.find('> *').length;
        var renderTemplate = templating.replace(/{i}/g, nblines + 1);

        $wrapper.append(renderTemplate);
        $.applyDataMask();
        Revolution.get("mde.accessible-function").giveTempFocus($wrapper.find('.js-added-line:last-child'));
    },

    conditionnalRadio: function (e) {
        var $obj = $(e.currentTarget);
        var group = $obj.data('fields-group');
        var targets = $obj.data('fields');
        var targetsArray = targets.split(', ');

        $(group).find('.js-conditional').hide();
        $(group).find('.js-conditional').find('[data-required]').removeAttr('required');

        for(i=0; i < targetsArray.length; i++) {
            var target = targetsArray[i];
            $(target).show();
            $(target).find('[data-required]').attr('required', true);
        }
    },

    initInputFile: function () {
        $('.js-inputfile').each(function (index, el) {
            var $label   = $(el).next('label'),
                labelVal = $label.html(),
                $formItem = $label.closest('.form-item');

            $(el).on('change', function (e) {
                var fileName = '';
                if (this.files && this.files.length > 1) {
                    fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                } else {
                    //fileName = e.target.value.split("\"").pop();
                    fileName = e.target.files[0].name;
                }

                if (fileName) {
                    $label.find('.result').text(fileName);
                    $formItem.find('.delete-inputfile').show();
                } else {
                    $label.text(labelVal);
                }
            });
        });
    },
    clearInputFile : function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('label').prev('[type="file"]').val('');
        $obj.closest('label').find('.result').text('');
        $obj.hide();
    },

    checkboxesCounter: function(e) {

        var $obj = $(e.currentTarget);
        var $label = $(e.currentTarget).next('label');
        var $parent = $obj.closest('.bk-options');
        var nbChecked = $parent.find(':checked').length;

        if (nbChecked > 0) {
            $parent.next('.ta-c').find(':checked').prop('checked', false);
        }

        if ($obj.is(':checked')) {
            $label.find('.label-number').html(nbChecked);
        } else {
            var valDisable = parseInt($label.find('.label-number').html());
            $parent.find(':checked').each(function(index, elem) {
                var val = parseInt($(elem).next('label').find('.label-number').html());
                if (val > valDisable) {
                    $(elem).next('label').find('.label-number').html(val - 1);
                }
            });
        }
    },

    uncheckOptions: function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('.ta-c').prev('.bk-options').find(':checked').prop('checked', false);
    },

    initFormWithParsley: function() {
        $('.js-form-parsley').each(function (index, el) {
            $(el).parsley();
        })
    },

    saveRemontee: function(element){
        if ($(element)[0].name === 'species') {
            var userUid = typeof drupalSettings !== 'undefined' ? drupalSettings.user.uid : 0;
            var userToken = $(element).data('token');
            var url = $(element).data('savePath');
            var essenceId = $($(element).parent().next('.js-list-choices').find('.bk-filter-choice')[0]).data('id') || $('.js-custom-select2[name="species"]').find(':selected').val();

            if (userUid && userToken && url && essenceId) {
                url = url.replace('_user_', userUid);

                $.ajax({
                    method: "POST",
                    url: url,
                    data: { id: essenceId, token: userToken }
                })
            }
        }
    },

    initSelect: function() {
        // Select2 omits aria-controls on the combobox and role="group" on nested
        // option lists (grouped results). The results list is appended to <body>
        // asynchronously after 'select2:open' fires, so a MutationObserver is used
        // instead of patching on the event itself (too early, elements not yet in the DOM).
        var patchSelect2Aria = function () {
            $('.select2-results__options--nested:not([role])').attr('role', 'group');

            // role="group" is not an allowed ARIA role on <li> (Select2's own optgroup
            // wrapper); the nested <ul> above already carries the real group role, so
            // demote the <li> to presentation and keep its label on the <ul>.
            $('li.select2-results__option[role="group"]').each(function (index, elem) {
                var $li = $(elem);
                var label = $li.attr('aria-label');
                $li.attr('role', 'presentation').removeAttr('aria-label');
                if (label) {
                    $li.find('> .select2-results__options--nested').attr('aria-label', label);
                }
            });

            $('.select2-results:not([role])').attr('role', 'region').attr('aria-label', 'Résultats de recherche');

            $('.select2-selection[aria-owns]').each(function (index, elem) {
                var $selection = $(elem);
                if (!$selection.attr('aria-controls')) {
                    $selection.attr('aria-controls', $selection.attr('aria-owns'));
                }
            });
        };

        new MutationObserver(patchSelect2Aria).observe(document.body, {childList: true, subtree: true});

        $('.js-custom-select2').each(_.bind(function (index, el) {
            $(el).select2({
                minimumResultsForSearch: Infinity,
                // dropdownParent: $(el).parent(),
            });

            $(el).on('select2:select', _.bind(function (e) {
                this.saveRemontee($(el));
            }, this))
        }, this))

        $('.js-custom-select2-multi').each(_.bind(function (index, el) {
            $(el).select2({
                minimumResultsForSearch: 0,
                multiple: true,
                // dropdownParent: $(el).parent(),
                maximumSelectionLength: $(el).attr('data-max-selection') ?  $(el).attr('data-max-selection') : 0,
                placeholder: {
                    id: '-1', // the value of the option
                    text: $(el).data('placeholder')
                },
                language: {
                    maximumSelected: function (e) {
                        return $(el).data('message');
                    }
                }
            }).val(null).trigger('change');

            $(el).on('change', function (e) {
                $(el).next('.select2-container').find('.select2-search__field').css('width', 'auto').attr('placeholder', $(el).data('placeholder'));
            })
            if ($(el).data('role') === "critere") {
                $(el).on('select2:select', _.bind(function (e) {
                    var $critereChoice = $(this.htmlBkCritereChoice(e.params.data.text, e.params.data.id, $(el), []));
                    $(el).closest('.field-wrapper').find(".js-list-criteres").append($critereChoice);
                }, this))


                $(el).on('select2:unselect', _.bind(function (e) {
                    $(el).closest('.field-wrapper').find(".js-list-criteres").find('[data-id="'+e.params.data.id+'"]').remove();
                }, this))

                // if option selected by default
                if ($(el).find('option[selected]').length) {
                    var dataIds = [];

                    $(el).find('option[selected]').each(_.bind(function(index, option){
                        dataIds.push($(option).val());

                        var default_criteria = drupalSettings.criteria[$(option).val()];

                        // Add critere choice
                        var $critereChoice = $(this.htmlBkCritereChoice($(option).html(), $(option).val(), $(el), default_criteria));
                        $(el).closest('.field-wrapper').find(".js-list-criteres").append($critereChoice);
                        $(el).next('.select2-container').find('.select2-search__field').css('width', 'auto').attr('placeholder', $(el).data('placeholder'));
                    }, this));

                    // Update the select2 values
                    $(el).val(dataIds).trigger('change');
                }

            } else {
                $(el).on('select2:select', _.bind(function (e) {
                    var $filterChoice = $(this.htmlBkFilterChoice(e.params.data.text, e.params.data.id, $(el), $(e.params.data.element).parent().hasClass('js-list-favorite')));
                    $(el).closest('.field-wrapper').find(".js-list-choices").append($filterChoice);

                    this.saveRemontee($(el));
                }, this))

                $(el).on('select2:unselect', _.bind(function (e) {
                    $(el).closest('.field-wrapper').find(".js-list-choices").find('[data-id="'+e.params.data.id+'"]').remove();

                    this.saveRemontee($(el));

                    // If we are on the page of species list
                    if ($('.js-form-compare-species').length) {
                        var $filter = $('.js-form-compare-species .bk-filter-choice');
                        var listIds = [];
                        for (var i = 0; i < $filter.length; i++) {
                            listIds.push($filter.eq(i).data('id'));
                        }
                        $("#species").attr('value', listIds.join(','));
                    }
                }, this))

                // if option selected by default
                if ($(el).find('option[selected]').length) {
                    var dataIds = [];

                    $(el).find('option[selected]').each(_.bind(function(index, option){
                        dataIds.push($(option).val());

                        // Add filter choice
                        var $filterChoice = $(this.htmlBkFilterChoice($(option).html(), $(option).val(), $(el), $(option).parent().hasClass('js-list-favorite')));
                        $(el).closest('.field-wrapper').find(".js-list-choices").append($filterChoice);
                        $(el).next('.select2-container').find('.select2-search__field').css('width', 'auto').attr('placeholder', $(el).data('placeholder'));
                    }, this));

                    // Update the select2 values
                    $(el).val(dataIds).trigger('change');
                }
            }
        }, this))
    },

    htmlBkFilterChoice: function(title, id, $select, isFavorite) {
        var $html = $($select.closest('.field-wrapper').find('.template-bk-filter-choice').html());
        $html.attr('data-id', id);
        $html.find('.choice-title').find('button').attr('data-species', id);
        $html.find('.choice-title').find('button').addClass(isFavorite ? 'is-favorite' : '');
        $html.find('.choice-title-text').html(title);

        $html.find('.choice-btn').on('click', function(e){
            $select.next().find('.select2-selection__rendered li.select2-selection__choice').each(function (index, el) {
                if ($(el).html().indexOf($(e.currentTarget).parent().find('.choice-title-text').html()) >= 0) {
                    $(el).find('.select2-selection__choice__remove').click();
                    $select.select2('close');
                }
            })

            // If we are on the page of species list
            if ($('.js-form-compare-species').length) {
                var $filter = $('.js-form-compare-species .bk-filter-choice');
                var listIds = [];
                for (var i = 0; i < $filter.length; i++) {
                    listIds.push($filter.eq(i).data('id'));
                }
                $("#species").attr('value', listIds.join(','));
            }
        })

        return $html;
    },

    htmlBkCritereChoice: function(title, id, $select, default_criteria) {
        var $html = $($('#template-bk-critere-choice').html());
        $html.attr('data-id', id);
        var $critereTitle = $html.find('.critere-title').html(title);
        $html.find('.critere-close').attr('aria-label', $html.find('.critere-close').attr('aria-label') + ' : ' + $critereTitle.text());

        $html.find('.js-unknow-checkbox').attr('id', $html.find('.js-unknow-checkbox').attr('id')+'_'+id);
        $html.find('.js-unknow-checkbox').prop('checked', default_criteria.unknow);
        $html.find('.js-unknow-checkbox').attr('name', $html.find('.js-unknow-checkbox').attr('name')+'_'+id);
        $html.find('.js-unknow-label').attr('for', $html.find('.js-unknow-label').attr('for')+'_'+id);

        $html.find('.js-no-filtering').attr('id', $html.find('.js-no-filtering').attr('id')+'_'+id);
        $html.find('.js-no-filtering').attr('name', $html.find('.js-no-filtering').attr('name')+'_'+id);
        $html.find('.js-no-filtering').prop('checked', default_criteria.filtering);
        $html.find('.js-no-filtering-label').attr('for', $html.find('.js-no-filtering-label').attr('for')+'_'+id);

        if (default_criteria.filtering === true) {
            $html.find('.field-wrapper-inline').css('opacity', 0.5).css('pointer-events', 'none');
        }

        $html.find('.critere-close').on('click', function(e){
            $select.next().find('.select2-selection__rendered li.select2-selection__choice').each(function (index, el) {
                if ($(el).html().indexOf($(e.currentTarget).parent().find('.critere-title').html()) >= 0) {
                    $(el).find('.select2-selection__choice__remove').click();
                    $select.select2('close');
                }
            })
        });

        $html.find('.js-no-filtering').on('click', function(){
            if(this.checked) {
                $(this).closest('.js-bk-filter-critere').find('.field-wrapper-inline').css("opacity", 0.5).css('pointer-events', 'none');
                // $(this).closest('.js-bk-filter-critere').find('input[name="unknow"]').attr("disabled", true);
                // $(this).closest('.js-bk-filter-critere').find('.js-double-range')[0].setAttribute('disabled', true);
            } else {
                $(this).closest('.js-bk-filter-critere').find('.field-wrapper-inline').removeAttr("style");
                // $(this).closest('.js-bk-filter-critere').find('input[name="unknow"]').removeAttr("disabled");
                // $(this).closest('.js-bk-filter-critere').find('.js-double-range')[0].removeAttribute('disabled');
            }
        });

        var table = ["A", "B", "C", "D"];
        var tableAssoc = {A: 0, B: 1, C: 2, D: 3};
        $html.find('.js-double-range').each(function (index, elem) {
            var slider = $(elem)[0];

            noUiSlider.create(slider, {
                start: [$(elem).data('min'), $(elem).data('max')],
                step: 1,
                tooltips: [true, true],
                connect: [false, true, false],
                range: {
                    'min': 0,
                    'max': 3
                },
                format: {
                    from: function ( value ) {
                        return value;
                    },
                    to: function ( value ) {
                        return table[value];
                    }
                  }
            });

            // noUiSlider handles have role="slider" but no accessible name by default.
            var $handles = $(slider).find('.noUi-handle');
            $handles.eq(0).attr('aria-label', 'Score minimum');
            $handles.eq(1).attr('aria-label', 'Score maximum');

            if (default_criteria.notation) {
                var val_start = default_criteria.notation[0];
                var val_end = default_criteria.notation[1];

                slider.noUiSlider.set([tableAssoc[val_start], tableAssoc[val_end]]);
            }
        });

        return $html;
    },

    toggleInputPassword : function(e) {
        var $obj = $(e.currentTarget);
        var $input = $obj.prev('input');
        if($input.attr('type') == 'password') {
            $input.attr('type', 'text').addClass('is-visible');
        } else {
            $input.attr('type', 'password').removeClass('is-visible');
        }
    },
    modifyAccount : function(e) {
        e.preventDefault();
        var $obj = $(e.currentTarget);
        var $form = $obj.closest('.form-modify');
        if($form.hasClass('active')) {
            $form.removeClass('active');
            $form.find('input, select, textarea').addAttr('readonly');
        } else {
            $obj.hide();
            $form.addClass('active');
            $form.find('input, select, textarea').removeAttr('readonly');
        }
    },
    clickFavorite : function(e) {
        var $obj = $(e.currentTarget);
        var userUid = typeof drupalSettings !== 'undefined' ? drupalSettings.user.uid : 0;
        var userToken = $obj.data('token');
        var essenceId = $obj.data('species');

        if($obj.hasClass('is-favorite')) {
            var url = $obj.data('favorite-delete-path');
            $obj.removeClass('is-favorite');

            if($obj.closest('.js-bk-remontee').length) {
                $obj.closest('.js-bk-remontee').fadeOut(500, function() {
                    $obj.closest('.js-bk-remontee').remove();
                });
            }
        } else {
            var url = $obj.data('favorite-add-path');
            $obj.addClass('is-favorite');
        }

        if (userUid && userToken && url && essenceId) {
            url = url.replace('_user_', userUid).replace('_id_', essenceId);
            url += "?token="+userToken;

            $.ajax({
                method: "POST",
                url: url
            })
        }
    },
    deleteAllFavorite : function(e) {
        var $obj = $(e.currentTarget);
        var userUid = typeof drupalSettings !== 'undefined' ? drupalSettings.user.uid : 0;
        var userToken = $obj.data('token');
        var url = $obj.data('favorite-delete-all-path');

        console.log('deleteAllFavorite');

        if (userUid && userToken && url) {
            url = url.replace('_user_', userUid);
            url += "?token="+userToken;

            if($obj.closest('.wrapper-delete-all').nextAll('.bk-remontee').length) {
                $obj.closest('.wrapper-delete-all').nextAll('.bk-remontee').fadeOut(500, function() {
                    $obj.closest('.wrapper-delete-all').nextAll('.bk-remontee').remove();
                });
            }

            $.ajax({
                method: "POST",
                url: url
            })
        }
    },
    getFavorite : function() {
        if($('.js-btn-favorite').length) {
            $('.js-btn-favorite').each(function(index, el) {
                var userUid = typeof drupalSettings !== 'undefined' ? drupalSettings.user.uid : 0;
                var userToken = $(el).data('token');
                var url = $(el).data('favorite-add-path');
                var essenceId = $(el).data('species');

                if (userUid && userToken && url && essenceId) {
                    url = url.replace('_user_', userUid).replace('_id_', essenceId);
                    url += "?token="+userToken;

                    $.get(url, function(data) {
                        if(data == true) {
                            $(el).addClass('is-favorite');
                        }
                    });
                }
            });
        }
    },

    tagFormWithoutLegend: function() {
        $('.bk-formulaire form fieldset').each(function (index, elem) {
            if ($(elem).find('legend').length == 0 || $(elem).find('legend.out').length) {
                $(elem).addClass('-without-legend');
            }
        })
    }

});
